import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=3322816b&scoped=true&"
import script from "./ShowMore.vue?vue&type=script&lang=ts&"
export * from "./ShowMore.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=3322816b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322816b",
  null
  
)

export default component.exports